// use getReceiptType helper to determine a receipt type
export enum AttachmentType {
  EDocument = 'EDocument',
  Scout = 'Scout',
  Upload = 'Upload',
}
